import { useQuery } from "react-query";
import { getApprovedInvoiceToday } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetApprovedInvoiceToday = () => {
  return useQuery("GetApprovedInvoiceToday", getApprovedInvoiceToday, {
    refetchOnWindowFocus: false,
  });
};
